// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import LoadingBar from 'react-redux-loading-bar'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import Textarea from 'components/Form/Textarea'
import File from 'components/Form/File'
import Checkbox from 'components/Form/Checkbox'
import Confirm from 'components/Confirm/Confirm'
import Loading from 'components/Loading/Loading'
import Send from 'components/svg/send.svg'
import Bell from 'components/svg/bell.svg'
import Close from 'components/svg/close-circle-outline.svg'
import { loopArray } from 'utilities/arrays'
import { getUrlParameter } from 'utilities/url'

// Redux:
import * as reduxTickets from 'actions/tickets'

class TicketRow extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isOpen: false,
			actionsIsOpen: false,
			confirmCloseTicket: false,
			reply: '',
			markAsResolved: false,
			sendReplyToRetailer: false,
			internalNotes: props.item.internal_notes,
			internalNotesFiles: [],
			confirmDeleteNotesAttachment: false,

			publicTicketFiles: [],
			confirmDeletePublicAttachment: false,
			publicAttachmentsIsDirty: false,
		}

		this.ref = React.createRef()
		this.refReply = React.createRef()
	}

	componentDidMount() {
		const { item } = this.props
		const ticketIDParam = getUrlParameter( 'ticket' )

		if ( ticketIDParam == item.id ) {
			this.openAndScrollTo()
		}

		window.addEventListener( 'openTicket', ( e ) => {
			if ( e.detail == item.id ) {
				this.openAndScrollTo()
			}
		}, false )
	}

	openAndScrollTo = () => {
		const { dispatch, item } = this.props

		dispatch( reduxTickets.setTicketMessagesAsSeen( item.id ) )

		this.setState( {
			isOpen: true
		} )

		setTimeout( () => {
			zenscroll.intoView( this.refReply.current, 800 )
		}, 600 )
	}

	handleToggleOpenState = () => {
		const { dispatch, item } = this.props
		const { isOpen } = this.state

		if ( ! isOpen ) {
			dispatch( reduxTickets.setTicketMessagesAsSeen( item.id ) )
		}

		this.setState( {
			isOpen: ! isOpen
		} )
	}

	handleToggleActionsOpenState = () => {
		const { actionsIsOpen } = this.state

		this.setState( {
			actionsIsOpen: ! actionsIsOpen
		} )
	}

	handleConfirmCloseTicket = () => {
		this.setState( {
			confirmCloseTicket: true,
			actionsIsOpen: false
		} )
	}

	handleCancelCloseTicket = () => {
		this.setState( {
			confirmCloseTicket: false
		} )
	}

	handleAcceptCloseTicket = () => {
		const { dispatch, item } = this.props

		dispatch( reduxTickets.closeTicket( item.id ) )

		this.setState( {
			confirmCloseTicket: false
		} )
	}

	handleChangeReply = ( id, value ) => {
		this.setState( {
			reply: value
		} )
	}

	handleChangeMisc = ( id, value ) => {
		this.setState( {
			[ id ]: value
		} )
	}

	handleSendReply = () => {
		const { dispatch, item } = this.props
		const { reply, markAsResolved, sendReplyToRetailer } = this.state

		dispatch( reduxTickets.sendMessage( item.id, reply, markAsResolved, sendReplyToRetailer ) )

		this.setState( {
			reply: ''
		} )
	}

	handleTextareaKeyDown = ( e ) => {
		// if ( e.keyCode == 13 && ! e.shiftKey ) {
		// 	e.preventDefault()
		// 	this.handleSendReply()
		// }
	}

	handleChangeNotesInput = ( id, value ) => {
		this.setState( {
			[ id ]: value,
			internalNotesIsDirty: true
		} )
	}

	handleSaveNotes = () => {
		const { dispatch, item } = this.props
		const { internalNotes, internalNotesFiles } = this.state

		dispatch( reduxTickets.saveInteralNotes( item.id, internalNotes, internalNotesFiles ) )

		this.setState( {
			internalNotesIsDirty: false,
			internalNotesFiles: []
		} )
	}

	handleDeleteInternalNoteAttachment = ( e ) => {
		e.preventDefault()
		e.stopPropagation()

		const id = e.currentTarget.getAttribute( 'data-id' )

		this.setState( {
			confirmDeleteNotesAttachment: id
		} )
	}

	handleAcceptDeleteNotesAttachment = () => {
		const { dispatch, item } = this.props
		const { confirmDeleteNotesAttachment } = this.state

		dispatch( reduxTickets.deleteInternalNoteAttachment( item.id, confirmDeleteNotesAttachment ) )

		this.setState( {
			confirmDeleteNotesAttachment: false
		} )
	}

	handleCancelDeleteNotesAttachment = () => {
		this.setState( {
			confirmDeleteNotesAttachment: false
		} )
	}

	handleChangePublicAttachmentsInput = ( id, value ) => {
		this.setState( {
			[ id ]: value,
			publicAttachmentsIsDirty: true
		} )
	}

	handleSavePublicAttachments = () => {
		const { dispatch, item } = this.props
		const { publicTicketFiles } = this.state

		dispatch( reduxTickets.savePublicAttachments( item.id, publicTicketFiles, () => {
			this.setState( {
				publicAttachmentsIsDirty: false,
				publicTicketFiles: []
			} )
		} ) )
	}

	handleDeletePublicAttachment = ( e ) => {
		e.preventDefault()
		e.stopPropagation()

		const id = e.currentTarget.getAttribute( 'data-id' )

		this.setState( {
			confirmDeletePublicAttachment: id
		} )
	}

	handleAcceptDeletePublicAttachment = () => {
		const { dispatch, item } = this.props
		const { confirmDeletePublicAttachment } = this.state

		dispatch( reduxTickets.deletePublicAttachment( item.id, confirmDeletePublicAttachment ) )

		this.setState( {
			confirmDeletePublicAttachment: false
		} )
	}

	handleCancelDeletePublicAttachment = () => {
		this.setState( {
			confirmDeletePublicAttachment: false
		} )
	}

	render() {
		const {
			item, accountData, notifications,
			isLoadingInternalNotes, isLoadingPublicAttachments, isDeletingPublicAttachment
		} = this.props
		const {
			isOpen, actionsIsOpen,
			confirmCloseTicket, reply,
			internalNotes, internalNotesIsDirty, internalNotesFiles, confirmDeleteNotesAttachment,
			publicAttachmentsIsDirty, publicTicketFiles, confirmDeletePublicAttachment
		} = this.state
		let className = '-ticket-row'
		const viewButtonText = isOpen ? 'Close' : 'View'
		let detailsClass = isOpen ? '-ticket-row-details is-open' : '-ticket-row-details'
		let statusClass = '-status'
		let actionsClass = actionsIsOpen ? '-actions is-open' : '-actions'
		let statusText = ''

		if ( ! item ) {
			return null
		}

		if ( actionsIsOpen ) {
			className += ' with-actions-open'
		}

		if ( 'new' == item.status ) {
			statusClass += ' is-new'
			statusText = 'New'
		} else if ( 'resolved' == item.status ) {
			statusClass += ' is-resolved'
			statusText = 'Resolved'
		} else if ( 'in-progress' == item.status ) {
			statusClass += ' is-in-progress'
			statusText = 'In progress'
		} else if (
			( 'awaiting-info-customer' == item.status && ! accountData.is_staff ) ||
			( 'awaiting-info-staff' == item.status && accountData.is_staff )
		) {
			statusClass += ' is-awaiting-info'
			statusText = 'Awaiting information'
		} else if (
			( 'awaiting-info-customer' == item.status && accountData.is_staff ) ||
			( 'awaiting-info-staff' == item.status && ! accountData.is_staff )
		) {
			statusClass += ' is-in-progress'
			statusText = 'In progress'
		}

		let daysSinceClass = '-since',
			daysSinceInt = parseInt( item.days_since_created, 10 )

		if ( daysSinceInt >= 31 ) {
			daysSinceClass += ' -since-31'
		} else if ( daysSinceInt >= 15 ) {
			daysSinceClass += ' -since-15'
		} else {
			daysSinceClass += ' -since-0'
		}

		let claimInfoClass = accountData.is_staff ? '-claim-info with-staff' : '-claim-info'

		return [
			<tr className={ className } ref={ this.ref } key={ item.id }>
				<td className="-td-id" data-label="ID">#{ item.id }</td>

				{ item.store_location &&
					<td className="-td-store" data-label="Store">{ item.store_location }</td>
				||
					<td className="-td-store" data-label="Store">{ item.store_name }</td>
				}
				<td className="-td-customer" data-label="Customer">{ item.customer_name }</td>
				<td className="-td-created" data-label="Date Received">{ item.created_display }</td>
				<td className="-td-since" data-label="Days Since Claim">
					<div className={ daysSinceClass }>{ item.days_since_created }</div>
				</td>
				<td className="-td-updated" data-label="Last Updated">{ item.updated_display }</td>
				<td className="-td-actions">
					{ ( accountData.is_staff && 'resolved' != item.status ) &&
						<div className={ actionsClass }>
							{ confirmCloseTicket &&
								<Confirm
									heading="Are you sure you want to close this ticket?"
									acceptText="Close this ticket"
									handleAccept={ this.handleAcceptCloseTicket }
									handleCancel={ this.handleCancelCloseTicket }
								/>
							}

							<div className="-dots" onClick={ this.handleToggleActionsOpenState }>···</div>

							<div className="-dropdown">
								<span onClick={ this.handleConfirmCloseTicket }>Close ticket</span>
							</div>
						</div>
					}
				</td>
				<td className="-td-notifications">
					{ ( notifications && !! notifications.length ) &&
						<div className="-notifications">
							<div className="-inner">
								<div className="-notifications-icon">
									<Bell />
								</div>

								<div className="-notifications-number">
									{ notifications.length }
								</div>
							</div>
						</div>
					}
				</td>
				<td className="-td-status">
					<div className={ statusClass }>{ statusText }</div>
				</td>
				<td className="-td-view">
					<button className="-view" onClick={ this.handleToggleOpenState }><span>{ viewButtonText }</span></button>
				</td>
			</tr>,

			<tr className={ detailsClass } key={ `${item.id}-details` }>
				<td colSpan="10">
					<div className="-wrap">
						<div className="-inner">
							<div className="-content">
								<div className="-customer-info">
									<span>
										<span className="-key">Name</span>
										<span className="-value">{ item.customer_name }</span>

										<span className="-key">Address</span>
										<span className="-value">{ item.customer_address_full }</span>

										<span className="-key">Phone</span>
										<span className="-value">{ item.customer_phone }</span>
									</span>
								</div>

								{ item.product &&
									<div className={ claimInfoClass }>
										<div className="-claim-info-text">
											{ item.product.product_name &&
												<div className="-item">
													<div className="-key">Product Name</div>
													<div className="-value">{ item.product.product_name }</div>
												</div>
											}

											{ item.product.product_size &&
												<div className="-item">
													<div className="-key">Product Size</div>
													<div className="-value">{ item.product.product_size }</div>
												</div>
											}

											{ item.product.serial_number &&
												<div className="-item">
													<div className="-key">Serial Number</div>
													<div className="-value">{ item.product.serial_number }</div>
												</div>
											}

											<div className="-item">
												<div className="-key">Does your mattress have any stains?</div>

												{ ( item.product.has_stains && 'yes' == item.product.has_stains ) &&
													<div className="-value">Yes</div>
												||
													<div className="-value">No</div>
												}
											</div>

											<div className="-item">
												<div className="-key">Have you read the warranty?</div>

												{ ( item.product.has_read_warrany && 'yes' == item.product.has_read_warrany ) &&
													<div className="-value">Yes</div>
												||
													<div className="-value">No</div>
												}
											</div>

											{ item.product.purchase_date &&
												<div className="-item">
													<div className="-key">When did you purchase the mattress?</div>
													<div className="-value">{ item.product.purchase_date }</div>
												</div>
											}

											{ item.product.problem_noticed &&
												<div className="-item">
													<div className="-key">When did you notice the problem?</div>
													<div className="-value">{ item.product.problem_noticed }</div>
												</div>
											}

											{ item.serial_number_not_found &&
												<div className="-item">
													<div className="-key">Serial number not found</div>
													<div className="-value"></div>
												</div>
											}

											{ item.order_date &&
												<div className="-item">
													<div className="-key">Order date</div>
													<div className="-value">{ item.order_date }</div>
												</div>
											}

											{ item.prod_date &&
												<div className="-item">
													<div className="-key">Prod date</div>
													<div className="-value">{ item.prod_date }</div>
												</div>
											}

											{ item.ship_date &&
												<div className="-item">
													<div className="-key">Ship date</div>
													<div className="-value">{ item.ship_date }</div>
												</div>
											}

											{ item.order_number &&
												<div className="-item">
													<div className="-key">Order number</div>
													<div className="-value">{ item.order_number }</div>
												</div>
											}

											{ item.po_number &&
												<div className="-item">
													<div className="-key">PO number</div>
													<div className="-value">{ item.po_number }</div>
												</div>
											}

											{ item.item_number &&
												<div className="-item">
													<div className="-key">Item number</div>
													<div className="-value">{ item.item_number }</div>
												</div>
											}

											{ item.item_description &&
												<div className="-item">
													<div className="-key">Item description</div>
													<div className="-value">{ item.item_description }</div>
												</div>
											}

											<div className="-item">
												<div className="-photos">
													{ item.product.serial_number_file_url &&
														<div className="-photo">
															<div>Serial Number Photo</div>

															<a href={ item.product.serial_number_file_url } target="_blank"><img src={ item.product.serial_number_file_url_thumb } alt="" /></a>
														</div>
													}

													{ item.product.receipt_file_url &&
														<div className="-photo">
															<div>Receipt Photo</div>

															<a href={ item.product.receipt_file_url } target="_blank"><img src={ item.product.receipt_file_url_thumb } alt="" /></a>
														</div>
													}

													{ item.product.photo_mattress_url &&
														<div className="-photo">
															<div>Mattress Photo</div>

															<a href={ item.product.photo_mattress_url } target="_blank"><img src={ item.product.photo_mattress_url_thumb } alt="" /></a>
														</div>
													}

													{ item.product.photo_foundation_file_url &&
														<div className="-photo">
															<div>Mattress Foundation Photo</div>

															<a href={ item.product.photo_foundation_file_url } target="_blank"><img src={ item.product.photo_foundation_url_thumb } alt="" /></a>
														</div>
													}

													{ item.product.photo_sagging_url &&
														<div className="-photo">
															<div>Mattress Sagging Photo</div>

															<a href={ item.product.photo_sagging_url } target="_blank"><img src={ item.product.photo_sagging_url_thumb } alt="" /></a>
														</div>
													}
												</div>
											</div>

											{ ( item.attachments && !! item.attachments.length ) &&
												<div className="-item">
													<div className={ isLoadingPublicAttachments ? '-attachments is-loading' : '-attachments' }>
														<div>Additional attachments</div>

														<div className="-inner">
															{ confirmDeletePublicAttachment &&
																<Confirm
																	heading="Are you sure you want to delete this attachment?"
																	acceptText="Delete"
																	handleAccept={ this.handleAcceptDeletePublicAttachment }
																	handleCancel={ this.handleCancelDeletePublicAttachment }
																/>
															}

															{ loopArray( item.attachments, ( key, item ) => {
																let className = ''

																if ( isDeletingPublicAttachment == item.id ) {
																	className = 'is-deleting'
																}

																if ( item.thumbnail ) {
																	return (
																		<a href={ item.url } className={ className } target="_blank" key={ item.url }>
																			<div className="-image">
																				<img src={ item.thumbnail } alt={ item.alt } />
																			</div>

																			<Close onClick={ this.handleDeletePublicAttachment } data-id={ item.id } />
																		</a>
																	)
																} else {
																	return (
																		<a href={ item.url } target="_blank" key={ item.url }>
																			<div className="-doc">{ item.alt }</div>

																			<Close onClick={ this.handleDeletePublicAttachment } data-id={ item.id } />
																		</a>
																	)
																}
															} ) }

															{ isLoadingPublicAttachments &&
																<div className="-image">
																	<Loading />
																</div>
															}
														</div>
													</div>
												</div>
											}
										</div>

										{ accountData.is_staff &&
											<div className={ isLoadingInternalNotes ? '-claim-info-notes is-loading' : '-claim-info-notes' }>
												{ isLoadingInternalNotes && <Loading /> }

												<div className="-inner">
													<h3>Internal Notes</h3>

													<p>These notes will only be visible to staff.</p>

													{ item.internal_notes_attachments &&
														<div className="-attachments">
															{ confirmDeleteNotesAttachment &&
																<Confirm
																	heading="Are you sure you want to delete this attachment?"
																	acceptText="Delete"
																	handleAccept={ this.handleAcceptDeleteNotesAttachment }
																	handleCancel={ this.handleCancelDeleteNotesAttachment }
																/>
															}

															{ loopArray( item.internal_notes_attachments, ( key, item ) => {
																if ( item.thumbnail ) {
																	return (
																		<a href={ item.url } target="_blank" key={ item.url }>
																			<div className="-image">
																				<img src={ item.thumbnail } alt={ item.alt } />
																			</div>

																			<Close onClick={ this.handleDeleteInternalNoteAttachment } data-id={ item.id } />
																		</a>
																	)
																} else {
																	return (
																		<a href={ item.url } target="_blank" key={ item.url }>
																			<div className="-doc">{ item.alt }</div>

																			<Close onClick={ this.handleDeleteInternalNoteAttachment } data-id={ item.id } />
																		</a>
																	)
																}
															} ) }
														</div>
													}

													<Textarea
														id="internalNotes"
														value={ internalNotes }
														onChange={ this.handleChangeNotesInput }
													/>

													<div className={ internalNotesIsDirty ? '-actions' : '-actions is-saved' }>
														<div className="button -attach" onClick={ this.handleAddAttachmentToNotes }>Attach files</div>

														<File
															id="internalNotesFiles"
															buttonLabel="Attach files"
															value={ internalNotesFiles }
															onChange={ this.handleChangeNotesInput }
															multiple={ false }
														/>

														<div className="button -save" disabled={ ! internalNotesIsDirty } onClick={ this.handleSaveNotes }>{ internalNotesIsDirty ? 'Save' : 'Saved' }</div>
													</div>
												</div>
											</div>
										}
									</div>
								}

								<div className="-content-inner">
									<div className="-messages">
										{ loopArray( item.comments, ( key, comment ) => {
											let className = comment.is_staff ? '-message is-staff' : '-message'
											let showName = true

											if ( item.comments[ key - 1 ] && item.comments[ key - 1 ].name == comment.name ) {
												showName = false
											}

											return (
												<div className={ className } key={ key }>
													{ showName &&
														<div className="-name">{ comment.name }</div>
													}

													<div className="-content">{ comment.content }</div>
												</div>
											)
										} ) }
									</div>

									<div className="-reply" ref={ this.refReply }>
										<Textarea
											rows="1"
											placeholder="Write a reply..."
											value={ reply }
											onChange={ this.handleChangeReply }
											expand={ true }
										/>

										<div className="-send" onClick={ this.handleSendReply }>
											<Send />
										</div>

										<div className="-send-actions">
											{ accountData.is_staff &&
												<div className="-mark-resolved">
													<Checkbox
														id="markAsResolved"
														label="Mark as resolved?"
														uncontrolled={ true }
														onChange={ this.handleChangeMisc }
													/>
												</div>
											}

											{ accountData.is_admin &&
												<div className="-send-to-retailer">
													<Checkbox
														id="sendReplyToRetailer"
														label="Also send email notification to store?"
														uncontrolled={ true }
														onChange={ this.handleChangeMisc }
													/>
												</div>
											}

											<div className={ ( publicAttachmentsIsDirty ) ? '-add-attachments' : '-add-attachments is-saved' }>
												<div className="button -attach" onClick={ this.handleAddPublicAttachmentToTicket }>Attach files</div>

												<File
													id="publicTicketFiles"
													buttonLabel="Attach files"
													value={ publicTicketFiles }
													onChange={ this.handleChangePublicAttachmentsInput }
													multiple={ false }
												/>

												<div className="button -save" disabled={ ! publicAttachmentsIsDirty } onClick={ this.handleSavePublicAttachments }>{ isLoadingPublicAttachments ? 'Uploading...' : 'Upload' }</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</td>
			</tr>
		]
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const { ticketsById } = state.tickets
	let item

	if ( ticketsById && ticketsById[ `id_${ownProps.itemId}` ] ) {
		item = ticketsById[ `id_${ownProps.itemId}` ]
	}

	return {
		item,
		accountData: state.user.accountData,
		// notificationsByTicketId: state.tickets.notificationsByTicketId,
		notifications: state.tickets.notificationsByTicketId[ `id_${ownProps.itemId}` ],
		isLoadingInternalNotes: state.tickets.isLoadingInternalNotes,
		isLoadingPublicAttachments: state.tickets.isLoadingPublicAttachments,
		isDeletingPublicAttachment: state.tickets.isDeletingPublicAttachment,
		ticketsById: state.tickets.ticketsById
	}
}

export default connect( mapStateToProps )( TicketRow )
